/** @format */

export const SHOW_GOBACK = {
  create: "create",
  edit: "edit",
};

export const PUBLIC_URL = {
  LOGIN: "/auth/login",
};

export const PRIVATE_ROOT = {
  DASHBOARD: "/",
  TASKS: "/tasks",
  PROJECTS: "/projects",
  PROJECTS_CREATE: "/projects/create",
  PROJECTS_DETAIL: "/projects/detail",
  USERS: "/users",
  SETTINGS: "/settings",
  ACCOUNT_CODES: "/account-codes",
  PAYMENT_VOUCHERS: "/payment-vouchers",
  PAYMENT_BANKINGS: "/payment-bankings",
  OPENING_BALANCE: "/opening-balance",
  COMPANIES: "/companies",
  CUSTOMERS: "/customers",
  OPENING_INVENTORIES: "/opening-inventories",
  RECEIPTS: "/receipts",
  RECEIPT_BANKINGS: "/receipt-bankings",
  RETURN_ORDERS: "/return-orders",
  OBJECTIVE_CUSTOMER_OR_SUPLIES: "/objective/customer-or-suplies",
  OBJECTIVE_EMPLOYEE: "/objective/employee",
  OBJECTIVE_DEPARTMENT: "/objective/department",
  OBJECTIVE_UNIT: "/objective/unit",

};

export const ACCOUNTING = {
  OPENING_INVENTORY: "accounting-opening-inventory",
  OPENING_DEBT: "accounting-opening-inventory",
  CASH_RECEIPT: "accounting-cash-receipt",
  CASH_PAYMENT: "accounting-cash-payment",
  BANK_RECEIPT: "accounting-bank-receipt",
  BANK_PAYMENT: "accounting-bank-payment",
  PURCHASE_DOCUMENT: "accounting-purchase-order",
  PURCHASE_RETURN: "accounting-purchase-return",
  SALES_DOCUMENT: "accounting-purchase-return",
  OTHER_DOCUMENT: "accounting-purchase-return",
  PRODUCTION_ORDER: "accounting-purchase-return",
  MATERIAL_SPLIT: "accounting-purchase-return",
  PAYROLL_LIST: "accounting-purchase-return",
  PAYROLL_PAYMENT: "accounting-purchase-return",
  INVENTORY_CHECK: "accounting-purchase-return",
  WMS_IN: "accounting-purchase-return",
  WMS_OUT: "accounting-purchase-return",
  WMS_TRANSFER: "accounting-purchase-return",
  RECALCULATE_COST: "accounting-purchase-return",
  NOTIFICATION: "accounting-purchase-return",
  CLOSE_BOOK: "accounting-purchase-return",
  ACCOUNTING_SETTING: "accounting-purchase-return",
}
